/**
 * EmptyState — used when a list or section has no data yet.
 * Icon (Lucide), heading, optional subtext, optional CTA slot.
 */
import type { ReactNode } from 'react';

export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  className,
}: {
  icon: React.ComponentType<{ className?: string; strokeWidth?: string | number }>;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={[
        'flex flex-col items-center justify-center gap-3 rounded-card border border-dashed border-border bg-surface/60 px-6 py-12 text-center',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <Icon className="h-10 w-10 text-ink-muted opacity-50" strokeWidth={1.5} />
      <div>
        <div className="text-h2 font-semibold text-ink">{title}</div>
        {description && (
          <div className="mt-1 max-w-sm text-small text-ink-muted">{description}</div>
        )}
      </div>
      {action && <div className="mt-2">{action}</div>}
    </div>
  );
}
